import axios from 'axios';

export const LMS_BASE_URL = process.env.REACT_APP_LMS_API_URL || "https://lms-main-api.wiserbee.ca"; // LMS API Base URL
export const HRMS_BASE_URL = process.env.REACT_APP_HRMS_API_URL || "https://hrms-api.wiserbee.ca";    // HRMS API Base URL

const getToken = () => {
  const user = JSON.parse(localStorage.getItem("user"));
  return user?.token;
};

// Generic request handler with configurable base URL
const createRequest = async (method, url, data = null, baseUrl = LMS_BASE_URL, isMultipart = false) => {
  const authToken = getToken();

  try {
    const headers = {
      'Content-Type': 'application/json',
    };

    // Add Authorization header if token exists
    if (authToken) {
      headers.Authorization = `Bearer ${authToken}`;
    }

    if (isMultipart) {
      headers['Content-Type'] = 'multipart/form-data';
    }

    const config = {
      method,
      url: `${baseUrl}${url}`,
      headers,
    };

    if (data !== null && data !== undefined) {
      config.data = data;
    }

    const response = await axios(config);
    return response;
  } catch (error) {
    console.error(`Error during ${method.toUpperCase()} request:`, error);

    if (error.response) {
      throw error.response; 
    } else if (error.request) {
      throw new Error("No response from server. Please check your connection.");
    } else {
      throw new Error("Unexpected error occurred. Please try again.");
    }
  }
};

// LMS-specific requests
export const getRequest = (endpoint) => createRequest('get', endpoint, null, LMS_BASE_URL);
export const deleteRequest = (endpoint) => createRequest('delete', endpoint, null, LMS_BASE_URL);
export const postRequest = (endpoint, data, isMultipart = false) =>
  createRequest('post', endpoint, data, LMS_BASE_URL, isMultipart);
export const updateRequest = (endpoint, data, isMultipart = false) =>
  createRequest('put', endpoint, data, LMS_BASE_URL, isMultipart);

// HRMS-specific requests
export const hrmsGetRequest = (endpoint) => createRequest('get', endpoint, null, HRMS_BASE_URL);
export const hrmsDeleteRequest = (endpoint) => createRequest('delete', endpoint, null, HRMS_BASE_URL);
export const hrmsPostRequest = (endpoint, data, isMultipart = false) =>
  createRequest('post', endpoint, data, HRMS_BASE_URL, isMultipart);
export const hrmsUpdateRequest = (endpoint, data, isMultipart = false) =>
  createRequest('put', endpoint, data, HRMS_BASE_URL, isMultipart);
export const hrmsPatchRequest = (endpoint, data, isMultipart = false) =>
  createRequest('patch', endpoint, data, HRMS_BASE_URL, isMultipart);

// HRMS POST request without body (for endpoints that don't expect a body)
export const hrmsPostRequestNoBody = (endpoint) => {
  const authToken = getToken();
  
  const headers = {
    'Content-Type': 'application/json',
  };

  // Add Authorization header if token exists
  if (authToken) {
    headers.Authorization = `Bearer ${authToken}`;
  }
  
  return axios({
    method: 'post',
    url: `${HRMS_BASE_URL}${endpoint}`,
    headers,
  });
};